import { styled } from '@mui/material/styles'
import { FC } from 'react'
import { theme } from '../../../modules/App/Providers/Theme/theme'
import { Header } from './Header'
import { Main } from './Main'

const Container = styled('div')`
  background-color: ${theme.palette.grey[100]};
  display: grid;
  grid-areas: 'header' 'main';
  grid-template-rows: auto 1fr;
  min-height: 100vh;
`

const FullPage: FC = ({ children }) => (
  <Container>
    <Header />
    <Main>{children}</Main>
  </Container>
)

export { FullPage }
